// extracted by mini-css-extract-plugin
export default {"dropzone":"DragAndDrop_dropzone__J9-vV","textLarge":"DragAndDrop_textLarge__JZKKp"};